import { Button, Input, InputNumber, Popconfirm, Select, Table, message } from 'antd';
import React, { Component } from 'react';
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import '../index.less';
import DetailSortModal from './DetailSortModal';
import SetScaleFactor from './SetScaleFactor';

const Option = Select.Option;

class DetailTable extends Component {

    getColumns = () => {
        const { tableConfig, updateType, index, handleChange, deleteRow, tableKey, activeKey, visitData = {}} = this.props;
        const columns = [];
        tableConfig.map(el => {
            const {
                label,
                name,
                type,
                typeProperty = {},
                show = true,    //判断该字段是否显示
                canEdit = false,    //判断该字段是否可修改
                newLineCanEdit = false,     //判断该新添加行的某个字段是否可修改
                width = 100,
            } = el;
            const {
                style = {},
                option = [],
                precision = 0,
            } = typeProperty;
            const domStyle = {
                width: '90%',
                ...style,
            };
            const getDom = (text, record, rowIndex) => {
                let Dom = '';
                switch (type) {
                    case 'Input':
                        Dom = <Input
                            style={domStyle}
                            placeholder="请输入"
                            value={text}
                            onChange={e => handleChange(e.target.value, name, index, rowIndex)}
                        />
                        break;
                    case 'InputNumber':
                        Dom = <InputNumber
                            style={domStyle}
                            className='custom-input-number'
                            min={0}
                            precision={precision}
                            placeholder="请输入"
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            value={text}
                            onChange={value => handleChange(value, name, index, rowIndex)}
                        />
                        break;
                    case 'Select':
                        {
                            const options = option.map(el => (
                                <Option key={el.value} value={el.value}>{el.label}</Option>
                            ));
                            Dom = <Select
                                style={domStyle}
                                placeholder="请选择"
                                allowClear
                                value={text}
                                onChange={value => handleChange(value, name, index, rowIndex)}
                            >
                                {options}
                            </Select>
                            break;
                        }
                }
                return Dom
            }
            if (show) {
                columns.push({
                    title: label,
                    dataIndex: name,
                    key: name,
                    width,
                    render: (text, record, rowIndex) => {
                        const { isNew = false, typeName, typeConfig, canEditServeCycle = true } = record; //新添加行的typeConfig为空
                        let textShow = (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''; //千分位显示
                        let rowCanEdit = canEdit;
                        //设置空值显示为'-'
                        if (typeName != '小计' && (text !== 0 && !text) && (name == 'postType' || name == 'unitPrice'|| name == 'manHour'|| name == 'serveCount'|| name == 'serveCycle' || name == 'siteNum'|| name == 'unitServicePrice' || name == 'caseNum' || name == 'visitCount' || name == 'price'))textShow = '-';

                        //项目管理详细版模块部分字段不可修改
                        if (tableKey == 'DATA_TYPE_PROJECT_MANAGER' && activeKey == 'DetailedQuotation'){
                            if ((name == 'serveCycle' && typeConfig == "CONFIG_INV_PLAN_TOOL") || (name == 'siteNum' && (typeConfig == "CONFIG_INV_PLAN_TOOL" || typeConfig == "CONFIG_INV_MEET_TRAIN" || typeConfig == "CONFIG_INV_INTERACT" || typeConfig == "CONFIG_INV_CRO_APPLICANT"))) {
                                rowCanEdit = false;
                            } else {
                                rowCanEdit = canEdit;
                            }
                        }

                        //非访视服务详细版模块部分字段不可修改
                        if (tableKey == 'DATA_TYPE_NO_VISIT' && activeKey == 'DetailedQuotation'){
                            rowCanEdit = name == 'serveCycle' ? canEditServeCycle : canEdit;
                        }

                        //第三方代垫费用，不统计时，小计费用不允许修改
                        let isCalcTotalPrice = true;
                        if (tableKey == 'DATA_TYPE_PREPAID' && visitData.calcTotalPrice == 0 && typeName == '小计') {
                            isCalcTotalPrice = false;
                        }

                        //每行的备注、费用字段都可修改，小计行除备注、费用字段外其他字段都不可修改
                        return ((rowCanEdit && typeName != '小计') || name == 'remarks' || (name == 'price' && isCalcTotalPrice) || (isNew && newLineCanEdit)) ? (updateType == 'edit' ?
                            getDom(text, record, rowIndex) : textShow) : textShow
                    }
                })
            }
        });

        if (updateType == 'edit') {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 40,
                render: (text, record, rowIndex) => {
                    const { canDelete } = record;
                    return <div>
                        {canDelete == 1 ? <Popconfirm title="确定要删除吗?" onConfirm={() => deleteRow(index, rowIndex)}>
                                <a>删除</a> </Popconfirm> : '-'}
                    </div>
                }
            })
        }
        return columns
    }

    render() {
        const { rowDatas } = this.props;
        return <Table
            bordered
            dataSource={rowDatas}
            columns={this.getColumns()}
            pagination={false}
        />
    }
}

const PageConfig = {
    DetailedQuotation: { //详细版
        queryUrl: API_URL.evaluate.getVisitDetailDataList,
        updateUrl: API_URL.evaluate.updateVisitDetailData,
        recalcUrl: API_URL.evaluate.reCalcClinicalQuotationDetail,
    },
    SimpleQuotation: {  //简版
        queryUrl: API_URL.evaluate.getVisitSimpleDataList,
        updateUrl: API_URL.evaluate.updateVisitSimpleData,
        recalcUrl: API_URL.evaluate.reCalcClinicalQuotationSimple,
    },
}

class QuotationDetail extends Component {

    state = {
        config: [
            { title: '中心启动服务费', key: 'DATA_TYPE_SITE_START', updateType: 'view' },
            { title: '患者预筛', key: 'DATA_TYPE_PRE_FILTER', updateType: 'view' },
            { title: '访视服务费', key: 'DATA_TYPE_VISIT', updateType: 'view' },
            { title: '非访视服务费', key: 'DATA_TYPE_NO_VISIT', updateType: 'view' },
            { title: '数据锁库和中心关闭', key: 'DATA_TYPE_SITE_CLOSE', updateType: 'view' },
            { title: '项目管理', key: 'DATA_TYPE_PROJECT_MANAGER', updateType: 'view' },
            // { title: '遗传办服务', key: 'DATA_TYPE_GENETIC_OFFICE', updateType: 'view' },
            { title: '质量管理', key: 'DATA_TYPE_QUALITY_MANAGER', updateType: 'view' },
            { title: '非盲服务', key: 'DATA_TYPE_UN_BIND', updateType: 'view' },
            { title: '其他', key: 'DATA_TYPE_OTHER', updateType: 'view' },
            { title: '第三方代垫费', key: 'DATA_TYPE_PREPAID', updateType: 'view' },
        ],
        crcHourUnitPrice: null,
        pmHourUnitPrice: null,
        feesTotalData: [],  //“服务费合计”数据
        feesTotalRemarksData: [],  //“备注”数据
        feesTotalType: 'view',  //“服务费合计”修改按钮控制
        feesTotalRemarksType: 'view',  //“备注”修改按钮控制
    }

    componentDidMount() {
        const { clinicalQuotationRecordId, activeKey } = this.props;
        this.loadData(clinicalQuotationRecordId, activeKey);
    }

    loadData = (clinicalQuotationRecordId, activeKey) => {
        if (!(clinicalQuotationRecordId && (activeKey == 'DetailedQuotation' || activeKey == 'SimpleQuotation'))) return
        const options = {
            method: 'POST',
            url: PageConfig[activeKey].queryUrl,
            data: { clinicalQuotationRecordId },
            dataType: 'json',
            doneResult: res => {
                const { crcHourUnitPrice, pmHourUnitPrice } = res;
                const { config } = this.state;
                config.map(el => {
                    const { rowDatas, visitData } = (res[el.key] || {});
                    const {
                        simpleTotalPrice,
                        simpleRemarks,
                        detailTotalPrice,
                        detailRemarks,
                        quotationVisitDataId,
                        showDetail,
                        showSimple,
                    } = (visitData || {});
                    //判断表格数据显示或隐藏（如果简版隐藏，详细版也需跟着隐藏）
                    const showTable = activeKey == 'DetailedQuotation' ? (showDetail == 1 && showSimple == 1) : showSimple == 1; 
                    //设置小计行
                    const totalRow = {
                        typeName: '小计',
                        price: activeKey == 'DetailedQuotation' ? detailTotalPrice : simpleTotalPrice,
                        remarks: activeKey == 'DetailedQuotation' ? detailRemarks : simpleRemarks,
                        quotationVisitDataId,
                    };  
                    //如果数据为空，则仅显示小计行数据；若数据为隐藏状态则都不显示
                    const data = (rowDatas && showTable) ? [...rowDatas, totalRow] : (showTable ? [totalRow] : []);
                    el.rowDatas = data;
                    el.visitData = visitData;
                    el.showTable = showTable;
                });
                this.setState({
                    config,
                    crcHourUnitPrice,   //岗位是CRC时的单价
                    pmHourUnitPrice,    //岗位是PM时的单价
                }, () => {
                    this.queryVisitFeesTotalData(clinicalQuotationRecordId);
                });
            }
        };
        $.sendRequest(options);
    }

    queryVisitFeesTotalData = (clinicalQuotationRecordId) => {
        if (!clinicalQuotationRecordId) return
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryVisitFeesTotalData,
            data: { clinicalQuotationRecordId },
            dataType: 'json',
            doneResult: res => {
                const { feesTotal, feesTotalRemarks } = (res.data || {})
                this.setState({
                    feesTotalData: [feesTotal],  //“服务费合计”数据
                    feesTotalRemarksData: feesTotalRemarks,  //“备注”数据
                })
            }
        };
        $.sendRequest(options);
    }

    getContent = () => {
        const { config, feesTotalData, feesTotalRemarksData, feesTotalType, feesTotalRemarksType } = this.state;
        const { activeKey, recordData } = this.props;
        const { bdBaAuth, evaluateStatus } = recordData;
        const MostContent = config.map((el, index) => {
            const { title, key, rowDatas, visitData, updateType, showTable } = el;
            //岗位下拉选项
            const postTypeOption = (key == 'DATA_TYPE_SITE_START' || key == 'DATA_TYPE_PREPAID') ? [{value: 'PM', label: 'PM'}, {value: 'CRC', label: 'CRC'}, {value: 'CRC/PM', label: 'CRC/PM'}] : [{value: 'PM', label: 'PM'}, {value: 'CRC', label: 'CRC'}];
            //能否修改单价权限
            const canEditUnitPrice = ((key == 'DATA_TYPE_SITE_START' || key == 'DATA_TYPE_NO_VISIT') && activeKey == 'SimpleQuotation') || key == 'DATA_TYPE_GENETIC_OFFICE' || key == 'DATA_TYPE_QUALITY_MANAGER' || key == 'DATA_TYPE_OTHER' || key == 'DATA_TYPE_PREPAID';  
            //是否可以设置比例系数
            const canSetScaleFactor = key == 'DATA_TYPE_SITE_START' || key == 'DATA_TYPE_PRE_FILTER' || key == 'DATA_TYPE_VISIT' || key == 'DATA_TYPE_NO_VISIT' || key == 'DATA_TYPE_SITE_CLOSE' || key == 'DATA_TYPE_PROJECT_MANAGER' || key == 'DATA_TYPE_UN_BIND';  
            //处理表格数据
            (rowDatas || []).map(rowData => {
                for (let key in rowData) {
                    if (rowData[key] === null) {
                        rowData[key] = undefined;
                    }
                }
            })
            // 配置表格内容
            const tableConfig = [
                {
                    label: visitData ? visitData.typeName : '',
                    name: 'typeName',
                    width: 160,
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_PRE_FILTER', 'DATA_TYPE_VISIT','DATA_TYPE_PROJECT_MANAGER', 'DATA_TYPE_GENETIC_OFFICE','DATA_TYPE_QUALITY_MANAGER','DATA_TYPE_UN_BIND','DATA_TYPE_OTHER','DATA_TYPE_PREPAID','DATA_TYPE_NO_VISIT','DATA_TYPE_SITE_CLOSE']),
                    newLineCanEdit: this.booleanEquals(key, ['DATA_TYPE_SITE_START']),
                    required: true,
                    type: 'Input',
                },
                {
                    label: '岗位',
                    name: 'postType',
                    width: 80,
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_PRE_FILTER', 'DATA_TYPE_GENETIC_OFFICE', 'DATA_TYPE_QUALITY_MANAGER','DATA_TYPE_OTHER','DATA_TYPE_PREPAID','DATA_TYPE_NO_VISIT','DATA_TYPE_SITE_CLOSE']) || (key == 'DATA_TYPE_SITE_START' && activeKey == 'SimpleQuotation'),
                    required: true,
                    newLineCanEdit: this.booleanEquals(key, ['DATA_TYPE_SITE_START','DATA_TYPE_VISIT','DATA_TYPE_UN_BIND']),
                    type: key == 'DATA_TYPE_QUALITY_MANAGER' ? 'Input' : 'Select',
                    typeProperty: {
                        option: postTypeOption
                    }
                },
                {
                    label: '单价（元/中心）',
                    name: 'unitPrice',
                    show: this.booleanEquals(key, ['DATA_TYPE_SITE_START', 'DATA_TYPE_GENETIC_OFFICE']),
                    canEdit: canEditUnitPrice,
                    required: canEditUnitPrice,
                    width: 100,
                    type: 'InputNumber',
                    typeProperty: {
                        precision: 2,
                    },
                },
                {
                    label: '单价（元/小时）',
                    name: 'unitPrice',
                    show: this.booleanEquals(key, ['DATA_TYPE_PRE_FILTER', 'DATA_TYPE_VISIT', 'DATA_TYPE_PROJECT_MANAGER','DATA_TYPE_QUALITY_MANAGER','DATA_TYPE_UN_BIND','DATA_TYPE_OTHER','DATA_TYPE_SITE_CLOSE']),
                    canEdit: canEditUnitPrice,
                    required: canEditUnitPrice,
                    width: 100,
                    type: 'InputNumber',
                    typeProperty: {
                        precision: 2,
                    },
                },
                {
                    label: '单价（元/月/中心）',
                    name: 'unitPrice',
                    show: this.booleanEquals(key, ['DATA_TYPE_PREPAID','DATA_TYPE_NO_VISIT']),
                    canEdit: canEditUnitPrice,
                    required: canEditUnitPrice,
                    width: 100,
                    type: 'InputNumber',
                    typeProperty: {
                        precision: 2,
                    },
                },
                {
                    label: '工时/中心',
                    name: 'manHour',
                    width: 80,
                    show: (this.booleanEquals(key, ['DATA_TYPE_SITE_START','DATA_TYPE_NO_VISIT']) && activeKey == 'DetailedQuotation') || this.booleanEquals(key, ['DATA_TYPE_PRE_FILTER','DATA_TYPE_UN_BIND']),
                    canEdit: (this.booleanEquals(key, ['DATA_TYPE_SITE_START','DATA_TYPE_NO_VISIT']) && activeKey == 'DetailedQuotation') || this.booleanEquals(key, ['DATA_TYPE_PRE_FILTER','DATA_TYPE_UN_BIND']),
                    required: (this.booleanEquals(key, ['DATA_TYPE_SITE_START','DATA_TYPE_NO_VISIT']) && activeKey == 'DetailedQuotation') || this.booleanEquals(key, ['DATA_TYPE_PRE_FILTER','DATA_TYPE_UN_BIND']),
                    type: 'InputNumber',
                    typeProperty: {
                        precision: 2,
                    },
                },
                {
                    label: '工时/每次',
                    name: 'manHour',
                    width: 80,
                    show: this.booleanEquals(key, ['DATA_TYPE_VISIT']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_VISIT']),
                    type: 'InputNumber',
                    typeProperty: {
                        precision: 2,
                    },
                },
                {
                    label: '工时',
                    name: 'manHour',
                    width: 80,
                    show: this.booleanEquals(key, ['DATA_TYPE_PROJECT_MANAGER','DATA_TYPE_SITE_CLOSE']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_PROJECT_MANAGER','DATA_TYPE_SITE_CLOSE']),
                    required: this.booleanEquals(key, ['DATA_TYPE_PROJECT_MANAGER','DATA_TYPE_SITE_CLOSE']),
                    type: 'InputNumber',
                    typeProperty: {
                        precision: 2,
                    },
                },
                {
                    label: '小时数/中心/次',
                    name: 'manHour',
                    width: 100,
                    show: this.booleanEquals(key, ['DATA_TYPE_QUALITY_MANAGER']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_QUALITY_MANAGER']),
                    required: this.booleanEquals(key, ['DATA_TYPE_QUALITY_MANAGER']),
                    type: 'InputNumber',
                },
                {
                    label: '小时数/中心/月',
                    name: 'manHour',
                    width: 100,
                    show: this.booleanEquals(key, ['DATA_TYPE_OTHER']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_OTHER']),
                    required: this.booleanEquals(key, ['DATA_TYPE_OTHER']),
                    type: 'InputNumber',
                    typeProperty: {
                        precision: 2,
                    },
                },
                {
                    label: '服务人数',
                    name: 'serveCount',
                    width: 60,
                    show: this.booleanEquals(key, ['DATA_TYPE_PREPAID']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_PREPAID']),
                    required: this.booleanEquals(key, ['DATA_TYPE_PREPAID']),
                    type: 'InputNumber',
                },
                {
                    label: '服务周期/月',
                    name: 'serveCycle',
                    width: 120,
                    show: this.booleanEquals(key, ['DATA_TYPE_PRE_FILTER','DATA_TYPE_PROJECT_MANAGER','DATA_TYPE_UN_BIND','DATA_TYPE_PREPAID','DATA_TYPE_NO_VISIT','DATA_TYPE_SITE_CLOSE']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_PRE_FILTER','DATA_TYPE_PROJECT_MANAGER','DATA_TYPE_UN_BIND','DATA_TYPE_PREPAID','DATA_TYPE_NO_VISIT']),
                    newLineCanEdit: key == 'DATA_TYPE_SITE_CLOSE',
                    required: this.booleanEquals(key, ['DATA_TYPE_PRE_FILTER','DATA_TYPE_UN_BIND','DATA_TYPE_PREPAID','DATA_TYPE_NO_VISIT']),
                    type: 'InputNumber',
                    typeProperty: {
                        precision: 2,
                    },
                },
                {
                    label: '中心数',
                    name: 'siteNum',
                    width: 60,
                    show: this.booleanEquals(key, ['DATA_TYPE_SITE_START', 'DATA_TYPE_PRE_FILTER','DATA_TYPE_PROJECT_MANAGER','DATA_TYPE_GENETIC_OFFICE','DATA_TYPE_UN_BIND','DATA_TYPE_OTHER','DATA_TYPE_NO_VISIT']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_SITE_START', 'DATA_TYPE_PRE_FILTER','DATA_TYPE_PROJECT_MANAGER','DATA_TYPE_GENETIC_OFFICE','DATA_TYPE_UN_BIND','DATA_TYPE_OTHER','DATA_TYPE_NO_VISIT']),
                    required: this.booleanEquals(key, ['DATA_TYPE_SITE_START', 'DATA_TYPE_PRE_FILTER','DATA_TYPE_GENETIC_OFFICE','DATA_TYPE_OTHER','DATA_TYPE_NO_VISIT']),
                    type: 'InputNumber',
                },
                {
                    label: '中心数(次数)',
                    name: 'siteNum',
                    width: 60,
                    show: this.booleanEquals(key, ['DATA_TYPE_QUALITY_MANAGER','DATA_TYPE_SITE_CLOSE']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_QUALITY_MANAGER','DATA_TYPE_SITE_CLOSE']),
                    required: this.booleanEquals(key, ['DATA_TYPE_QUALITY_MANAGER','DATA_TYPE_SITE_CLOSE']),
                    type: 'InputNumber',
                },
                {
                    label: '服务费/次',
                    name: 'unitServicePrice',
                    width: 120,
                    show: this.booleanEquals(key, ['DATA_TYPE_VISIT']),
                },
                {
                    label: '访视次数',
                    name: 'visitCount',
                    width: 80,
                    show: this.booleanEquals(key, ['DATA_TYPE_VISIT']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_VISIT']),
                    required: this.booleanEquals(key, ['DATA_TYPE_VISIT']),
                    type: 'InputNumber',
                    typeProperty: {
                        min: 0,
                    },
                },
                {
                    label: '例数',
                    name: 'caseNum',
                    width: 60,
                    show: this.booleanEquals(key, ['DATA_TYPE_VISIT']),
                    required: this.booleanEquals(key, ['DATA_TYPE_VISIT']),
                    canEdit: this.booleanEquals(key, ['DATA_TYPE_VISIT']),
                    type: 'InputNumber',
                },
                {
                    label: '费用',
                    name: 'price',
                    width: 120,
                    required: true,
                    canEdit: true,
                    type: 'InputNumber',
                    typeProperty: {
                        precision: 2,
                    },
                },
                {
                    label: '备注',
                    name: 'remarks',
                    width: 120,
                    type: 'Input',
                },
            ];
            return visitData && <div className='detail_content'>
                        <div className='content_header'>
                            <div className='header_title'>{title}</div>
                            {
                                (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') &&
                                    <div className='header_button'>
                                    {
                                        (updateType == 'view' && showTable) && <Button
                                            className='button_item'
                                            key='update'
                                            type="primary"
                                            onClick={() => this.update(index)}
                                        >修改</Button>
                                    }
                                    {
                                        (updateType == 'view' && showTable) && <Popconfirm title="确定要重新计算吗?" onConfirm={() => this.calculate(key)}>
                                        <Button
                                            className='button_item'
                                            key='calculate'
                                            type="primary"
                                        >{activeKey == 'SimpleQuotation'? '重置报价' : '重新计算'}</Button> </Popconfirm>  
                                    }
                                    {
                                        (updateType == 'view' && showTable) && <Button
                                            className='button_item'
                                            key='sort'
                                            type="primary"
                                            onClick={() => this.showDetailSortModal(el, activeKey)}
                                        >排序调整</Button>
                                    }
                                    {
                                        updateType == 'view' && <Button
                                            className='button_item'
                                            key='conceal'
                                            type="primary"
                                            onClick={() => this.conceal(key, showTable)}
                                        >{showTable ? '隐藏显示' : '取消隐藏显示'}</Button>
                                    }
                                    {
                                        (updateType == 'view' && showTable && activeKey == 'SimpleQuotation' && canSetScaleFactor) && <Button
                                            className='button_item'
                                            key='setScaleFactor'
                                            type="primary"
                                            onClick={() => this.SetScaleFactorRef.show(key, visitData, activeKey)}
                                        >设置比例系数</Button>
                                    }
                                    {
                                        (updateType == 'view' && key == 'DATA_TYPE_PREPAID' && showTable && activeKey == 'SimpleQuotation') && <Button
                                            className="btn-yellow"
                                            key='updateVisitPrepaidData'
                                            type="primary"
                                            onClick={() => this.updateVisitPrepaidData()}
                                        >{visitData.calcTotalPrice == 0 ? '统计代垫费用' : '不统计代垫费用'}</Button>
                                    }
                                    {
                                        (updateType == 'view' && key == 'DATA_TYPE_NO_VISIT' && showTable && activeKey == 'SimpleQuotation') && <Button
                                            className="btn-yellow"
                                            key='updateNoVisitHaveSurvival'
                                            type="primary"
                                            onClick={() => this.updateNoVisitHaveSurvival(visitData.canSetHaveSurvival)}
                                        >{visitData.canSetHaveSurvival ? '有生存随访阶段' : '无生存随访阶段'}</Button>
                                    }
                                    {
                                        updateType == 'edit' && <Button
                                            className='button_item'
                                            key='save'
                                            type="primary"
                                            onClick={() => this.save(index, tableConfig)}
                                        >保存</Button>
                                    }
                                    {
                                        updateType == 'edit' && <Button
                                            className='button_item'
                                            key='add'
                                            type="primary"
                                            onClick={() => this.add(index, canEditUnitPrice)}
                                        >添加</Button>
                                    }
                                    </div>
                            }
                        </div>
                        { 
                            key === 'DATA_TYPE_VISIT' && <div style={{ color: 'red', marginBottom: 10 }}>访视评估下，访视周期计划基础工时包含SAE、影像刻盘上次、PK采血、切片病理工时，请按需对工时进行调整</div>
                        }
                        <DetailTable
                            index={index}
                            tableKey={key}
                            activeKey={activeKey}
                            rowDatas={rowDatas}
                            visitData={visitData}
                            updateType={updateType}
                            tableConfig={tableConfig}
                            handleChange={this.handleChange}
                            deleteRow={this.deleteRow}
                        />
                    </div>
        });

        const MinorContent = <div>
            <div className='detail_content'>
                <div className='content_header'>
                    <div className='header_title'>服务费合计</div>
                    {
                        (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') && <div className='header_button'>
                            {
                                feesTotalType == 'view' && <Button
                                    className='button_item'
                                    key='feesTotalUpdate'
                                    type="primary"
                                    onClick={() => this.setState({ feesTotalType: 'edit' })}
                                >修改</Button>
                            }
                            {
                                feesTotalType == 'edit' && <Button
                                    className='button_item'
                                    key='feesTotalSave'
                                    type="primary"
                                    onClick={() => this.remarksSave('feesTotal')}
                                >保存</Button>
                            }
                        </div>
                    }
                </div>
                <Table
                    bordered
                    rowKey={record => record.quotationVisitFeesTotalId}
                    dataSource={feesTotalData}
                    columns={this.getFeesTotalColumns()}
                    pagination={false}
                />
            </div>
            <div className='detail_content'>
                <div className='content_header'>
                    <div className='header_title'>备注</div>
                    {
                        (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') && <div className='header_button'>
                            {
                                feesTotalRemarksType == 'view' && <Button
                                    className='button_item'
                                    key='remarkUpdate'
                                    type="primary"
                                    onClick={() => this.setState({ feesTotalRemarksType: 'edit' })}
                                >修改</Button>
                            }
                            {
                                feesTotalRemarksType == 'edit' && <Button
                                    className='button_item'
                                    key='remarkSave'
                                    type="primary"
                                    onClick={() => this.remarksSave('feesTotalRemarks')}
                                >保存</Button>
                            }
                        </div>
                    }
                </div>
                <Table
                    bordered
                    rowKey={record => record.quotationVisitFeesTotalRemarksId}
                    dataSource={feesTotalRemarksData}
                    columns={this.getRemarksColumns()}
                    pagination={false}
                />
            </div>
        </div>

        return <div>
            {MostContent}
            {MinorContent}
        </div>
    }

    updateVisitPrepaidData = () => {
        const { activeKey, clinicalQuotationRecordId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.updateVisitPrepaidData,
            data: {
                clinicalQuotationRecordId,
                dataType: 'DATA_TYPE_PREPAID',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData(clinicalQuotationRecordId, activeKey);
            }
        };
        $.sendRequest(options);
    }

    updateNoVisitHaveSurvival = (haveSurvival) => {
        const { activeKey, clinicalQuotationRecordId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.updateNoVisitHaveSurvival,
            data: {
                clinicalQuotationRecordId,
                haveSurvival,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData(clinicalQuotationRecordId, activeKey);
            }
        };
        $.sendRequest(options);
    }

    getFeesTotalColumns = () => {
        const { feesTotalType } = this.state;
        const { activeKey } = this.props;
        const priceName = activeKey == 'DetailedQuotation' ? 'detailTotalPrice' : 'simpleTotalPrice';
        const remarksName = activeKey == 'DetailedQuotation' ? 'detailRemarks' : 'simpleRemarks';
        const columns = [
            {
                title: '',
                dataIndex: 'typeName',
                key: 'typeName',
                width: 120,
            },
            {
                title: '费用',
                dataIndex: priceName,
                key: priceName,
                width: 120,
                render: (text) => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            },
            {
                title: '备注',
                dataIndex: remarksName,
                key: remarksName,
                width: 120,
                render: (text, record, index) => {
                    return feesTotalType == 'edit' ? <Input
                        style={{ width: '90%' }}
                        placeholder="请输入"
                        value={text}
                        onChange={e => this.handleRemarksChange(e.target.value, remarksName, index)}
                    /> : text
                }
            },
        ];
        return columns
    }

    getRemarksColumns = () => {
        const { feesTotalRemarksType } = this.state;
        const columns = [
            {
                title: '备注',
                dataIndex: 'remarks',
                key: 'remarks',
                width: 400,
                render: (text, record, index) => {
                    return feesTotalRemarksType == 'edit' ? <Input
                        style={{ width: '90%' }}
                        placeholder="请输入"
                        value={text}
                        onChange={e => this.handleRemarksChange(e.target.value, 'remarks', index)}
                    /> : text
                }
            },
        ];
        return columns
    }

    handleRemarksChange = (value, key, index) => {
        const { feesTotalData, feesTotalRemarksData } = this.state;
        if (key == 'remarks') {
            feesTotalRemarksData[index][key] = value;
        } else {
            feesTotalData[index][key] = value;
        }
        this.setState({ feesTotalData, feesTotalRemarksData });
    }

    remarksSave = (type) => {
        const { clinicalQuotationRecordId, activeKey } = this.props;
        const { feesTotalData, feesTotalRemarksData } = this.state;
        const remarksName = activeKey == 'DetailedQuotation' ? 'detailRemarks' : 'simpleRemarks';  //服务费合计备注名称
        const priceName = activeKey == 'DetailedQuotation' ? 'detailTotalPrice' : 'simpleTotalPrice'; //服务费合计费用名称 

        const url = activeKey == 'DetailedQuotation' ? API_URL.evaluate.updateFeesTotalDetailData : API_URL.evaluate.updateFeesTotalSimpleData;

        let sendData = {};
        sendData[`feesTotal.${remarksName}`] = feesTotalData[0][remarksName];
        sendData[`feesTotal.${priceName}`] = feesTotalData[0][priceName];
        feesTotalRemarksData.map((el, index) => {
            sendData[`feesTotalRemarks[${index}].quotationVisitFeesTotalRemarksId`] = el.quotationVisitFeesTotalRemarksId;
            sendData[`feesTotalRemarks[${index}].remarks`] = el.remarks;
        });
        const options = {
            method: 'POST',
            url,
            data: { clinicalQuotationRecordId, ...sendData },
            dataType: 'json',
            doneResult: res => {
                message.success('修改成功');
                if (type == 'feesTotal') {
                    this.setState({ feesTotalType: 'view' });
                } else {
                    this.setState({ feesTotalRemarksType: 'view' });
                }
                this.loadData(clinicalQuotationRecordId, activeKey);
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, rowKey, index, rowIndex) => {
        const { activeKey } = this.props;
        const { config, crcHourUnitPrice, pmHourUnitPrice } = this.state;
        const { rowDatas = [], visitData = {}, key } = config[index];
        rowDatas[rowIndex][rowKey] = value;
        const { postType } = rowDatas[rowIndex];
        //计算合计行的费用值
        const calculateTotalPrice = () => {
            let totalPrice = 0;
            rowDatas.map((el, index, arr) => {
                if (arr.length - 1 !== index) {
                    totalPrice = totalPrice + (el.price || 0);
                }
            });
            rowDatas[rowDatas.length - 1].price = Number(totalPrice.toFixed(2));
        }
        //计算某行的费用值
        const filterAssign = (key) => {
            const {
                unitPrice = 1, //单价
                manHour = 1, //工时/中心
                serveCount = 1, //服务人数
                serveCycle = 1, //服务周期/月
                siteNum = 1, //中心数
                visitCount = 1, //访视次数
                caseNum = 1, //例数
            } = rowDatas[rowIndex];
            switch (key) {
                case 'DATA_TYPE_SITE_START':
                    if (activeKey === 'DetailedQuotation') {
                        rowDatas[rowIndex].price = Number((unitPrice * manHour * siteNum).toFixed(2));
                    } else {
                        rowDatas[rowIndex].price = Number((unitPrice * siteNum).toFixed(2));
                    }
                    break;
                case 'DATA_TYPE_PRE_FILTER':
                case 'DATA_TYPE_UN_BIND':
                case 'DATA_TYPE_PROJECT_MANAGER':
                    rowDatas[rowIndex].price = Number((unitPrice * manHour * serveCycle * siteNum).toFixed(2));
                    break;
                case 'DATA_TYPE_VISIT':
                    rowDatas[rowIndex].unitServicePrice = Number((unitPrice * manHour).toFixed(2));
                    rowDatas[rowIndex].price = Number((unitPrice * manHour * visitCount * caseNum).toFixed(2));
                    break;
                case 'DATA_TYPE_GENETIC_OFFICE':
                    rowDatas[rowIndex].price = Number((unitPrice * siteNum).toFixed(2));
                    break;
                case 'DATA_TYPE_QUALITY_MANAGER':
                case 'DATA_TYPE_OTHER':
                case 'DATA_TYPE_SITE_CLOSE':
                    rowDatas[rowIndex].price = Number((unitPrice * manHour * siteNum).toFixed(2));
                    break;
                case 'DATA_TYPE_PREPAID':
                    rowDatas[rowIndex].price = Number((unitPrice * serveCount * serveCycle).toFixed(2));
                    break;
                case 'DATA_TYPE_NO_VISIT':
                    if (activeKey === 'DetailedQuotation') {
                        rowDatas[rowIndex].price = Number((unitPrice * manHour * serveCycle  * siteNum).toFixed(2));
                    } else {
                        rowDatas[rowIndex].price = Number((unitPrice * serveCycle  * siteNum).toFixed(2));
                    }
                    break;
                default:
                    break;
            }
            if (key == 'DATA_TYPE_PREPAID' && visitData.calcTotalPrice == 0) {
                rowDatas[rowDatas.length - 1].price = 0;
            } else {
                calculateTotalPrice();
            }
        }
        switch (rowKey) {
            case 'unitPrice':
            case 'manHour':
            case 'siteNum':
            case 'serveCycle':
            case 'visitCount':
            case 'caseNum':
            case 'serveCount':
                filterAssign(key);
                break;
            case 'postType':
                if (((key == 'DATA_TYPE_SITE_START' || key == 'DATA_TYPE_NO_VISIT') && activeKey === 'DetailedQuotation') || key == 'DATA_TYPE_PRE_FILTER' || key == 'DATA_TYPE_UN_BIND' || key == 'DATA_TYPE_VISIT'|| key == 'DATA_TYPE_OTHER' || key == 'DATA_TYPE_SITE_CLOSE') {
                    rowDatas[rowIndex].unitPrice = postType == 'CRC' ? crcHourUnitPrice : pmHourUnitPrice;
                }
                filterAssign(key);
                break;
            case 'price':
                rowDatas[rowIndex].price = value;
                if (rowIndex !== rowDatas.length - 1) {
                    if (key == 'DATA_TYPE_PREPAID' && visitData.calcTotalPrice == 0) {
                        rowDatas[rowDatas.length - 1].price = 0;
                    } else {
                        calculateTotalPrice();
                    }
                } 
                break;
            default:
                break;
        }

        this.setState({ config });
    }

    update = (index) => {
        const { config } = this.state;
        config[index].updateType = 'edit';
        this.setState({ config });
    }

    save = (index, tableConfig) => {
        const { config } = this.state;
        const { activeKey, clinicalQuotationRecordId } = this.props;
        const { rowDatas, key } = config[index];
        //必填校验
        let emptyValue = '';
        tableConfig.map(configData => {
            if (configData.required) {
                rowDatas.map((rowData, index, arr) => {
                    if (index !== arr.length - 1) {  //最后一行小计不参与判断
                        if (key == 'DATA_TYPE_NO_VISIT') { 
                            //非访视服务模块，给部分不需要修改的字段，不进行校验必填
                            if (configData.name == 'serveCycle') {
                                if (rowData.canEditServeCycle && rowData[configData.name] !== 0 && !rowData[configData.name]) {
                                    emptyValue = configData.label;
                                    return
                                }
                            } else {
                                if (rowData[configData.name] !== 0 && !rowData[configData.name]) {
                                    emptyValue = configData.name == 'typeName' ? '子类别名称' : configData.label;
                                    return
                                }
                            }
                        } else {
                            if (rowData[configData.name] !== 0 && !rowData[configData.name]) {
                                emptyValue = configData.name == 'typeName' ? '子类别名称' : configData.label;
                                return
                            }
                        }
                    }
                });
            }
        });
        if (emptyValue !== '') return message.warning(`${emptyValue}不能为空！`);
        //赋值给后台传的内容
        let sendData = {};  //存放传给后台内容的对象
        rowDatas.map((rowData, index, arr) => {
            if (index !== arr.length - 1) {
                for (let rowkey in rowData) {
                    sendData[`rowDatas[${index}].${rowkey}`] = rowData[rowkey];
                }
            } else {
                sendData[`visitData.quotationVisitDataId`] = rowData.quotationVisitDataId;
                sendData[`visitData.${activeKey == 'DetailedQuotation' ? 'detailRemarks' : 'simpleRemarks'}`] = rowData.remarks;
                sendData[`visitData.${activeKey == 'DetailedQuotation' ? 'detailTotalPrice' : 'simpleTotalPrice'}`] = rowData.price;
            }
        });
        const options = {
            method: 'POST',
            url: PageConfig[activeKey].updateUrl,
            data: {
                clinicalQuotationRecordId,
                dataType: key,
                ...sendData,
            },
            dataType: 'json',
            doneResult: res => {
                message.success('修改成功');
                config[index].updateType = 'view';  //表格切换到查看状态
                this.setState({
                    config,
                }, () => this.loadData(clinicalQuotationRecordId, activeKey));
            }
        };
        $.sendRequest(options);
    }

    deleteRow = (index, rowIndex) => {
        const { config } = this.state;
        const { rowDatas } = config[index];
        rowDatas.splice(rowIndex, 1);
        //删除行时刷新合计行价格
        let totalPrice = 0;
        rowDatas.map((el, index, arr) => {
            if (arr.length - 1 !== index) {
                totalPrice = totalPrice + (el.price || 0);
            }
        });
        rowDatas[rowDatas.length - 1].price = totalPrice.toFixed(2);
        this.setState({ config });
    }

    add = (index, canEditUnitPrice) => {
        const { config, pmHourUnitPrice, crcHourUnitPrice } = this.state;
        const { activeKey } = this.props;
        const { rowDatas, key } = config[index];
        //设置岗位默认值
        let postType = 'CRC';
        if (key == 'DATA_TYPE_PROJECT_MANAGER') {
            postType = 'PM';
        } else if (key == 'DATA_TYPE_QUALITY_MANAGER') {
            postType = '';
        }
        
        //设置单价默认值
        let unitPrice = 0;
        if (canEditUnitPrice) {
            if (key == 'DATA_TYPE_GENETIC_OFFICE' || key == 'DATA_TYPE_OTHER') {
                unitPrice = postType == 'PM' ? pmHourUnitPrice : crcHourUnitPrice;
            } else {
                unitPrice = undefined;
            }
        } else {
            unitPrice = postType == 'PM' ? pmHourUnitPrice : crcHourUnitPrice;
        }
        const newRow = {
            typeName: '',
            isNew: true,  //判断是否为新添加的行
            canDelete: 1,  //令新添加的行可删除
            postType,
            unitPrice,
            visitCount: key == 'DATA_TYPE_VISIT' ? 1 : undefined,
            remarks: (key == 'DATA_TYPE_PROJECT_MANAGER' && activeKey == 'SimpleQuotation') ? '按中心数*周期（启动后）' : undefined,
        }
        rowDatas.splice(rowDatas.length - 1, 0, newRow);
        this.setState({ config });
    }

    conceal = (key, showTable) => {
        const { clinicalQuotationRecordId, activeKey } = this.props;
        const isShow = showTable ? 0 : 1;  //showTable=true时，表格是显示状态，传0使表格隐藏；反之传1令表格显示。
        const url = activeKey == 'DetailedQuotation' ? API_URL.evaluate.updateVisitDataShowDetail : API_URL.evaluate.updateVisitDataShowSimple;
        const options = {
            method: 'POST',
            url,
            data: {
                clinicalQuotationRecordId,
                dataType: key,
                showDetail: isShow,
                showSimple: activeKey == 'DetailedQuotation' ? undefined : isShow,
            },
            dataType: 'json',
            doneResult: res => {
                this.loadData(clinicalQuotationRecordId, activeKey);
            }
        };
        $.sendRequest(options);
    }

    showDetailSortModal = (obj, activeKey) => {
        this.DetailSortModalRef.show(obj, activeKey);
    }

    calculate = (key) => {
        const { activeKey, clinicalQuotationRecordId } = this.props;
        const options = {
            method: 'POST',
            url: PageConfig[activeKey].recalcUrl,
            data: {
                clinicalQuotationRecordId,
                dataType: key,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData(clinicalQuotationRecordId, activeKey);
            }
        };
        $.sendRequest(options);
    }

    //判断字段是否等于某些值
    booleanEquals = (key, value = []) => {
        return value.some((el) => key === el);
    };

    render() {
        const { activeKey, clinicalQuotationRecordId } = this.props;
        return (
            <div>
                <div style={{ fontSize: 20, fontWeight: 600, textAlign: 'center', margin: '20px 0' }}>
                    津石SMO服务费报价
                </div>
                {this.getContent()}
                <DetailSortModal
                    ref={el => this.DetailSortModalRef = el}
                    loadData={this.loadData}
                    activeKey={activeKey}
                    clinicalQuotationRecordId={clinicalQuotationRecordId}
                />
                <SetScaleFactor
                    ref={el => this.SetScaleFactorRef = el}
                    loadData={this.loadData}
                />
            </div>
        )
    }
}

export default QuotationDetail



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/QuotationDetail.js